import React, { useEffect, useState, useRef } from 'react'
import { Link, NavLink, useHistory, useLocation } from 'react-router-dom'
import Swal from 'sweetalert2'
import socket from '../Components/socket'
import '../css/landing.css'
import Rightcontainer from '../Components/Rightcontainer'
import Downloadbutton from '../Components/Downloadbutton'
import io from '../Components/socket'
import Header from '../Components/Header'
import { Token } from '@mui/icons-material'


export default function Landing({ userAllData }) {
  const history = useHistory()
  const [open, setOpen] = useState(false)
  // const [userAllData, setUserAllData] = useState()

  const addsetting = localStorage.getItem('sitSetting')
  const addCaseSetting = JSON.parse(addsetting)
  const udata = JSON.parse(localStorage.getItem("udata"));

    
  useEffect(() => {
    handleClick();
  }, [])

   const handleClick = () => {
       if (udata?.verified === "unverified") {
        //  e.preventDefault(); // page pe jaane se roke
         Swal.fire({
           icon: "warning",
           html: `
       <h4 style="color:white; margin-bottom:10px;">
         Please complete KYC
       </h4>
       <p style="color:white;">
         You need to complete your KYC before proceeding.
       </p>
     `,
           background: "linear-gradient(135deg, #1e3a8a, #0f172a)",
           confirmButtonText: "Verify Now",
           confirmButtonColor: "#f59e0b",
         }).then((result) => {
           if (result.isConfirmed) {
             history.push("/Profile"); // ✅ redirect
           }
         });
   
         return;
       }
       history.push("/");
     };

  return (
    <>
      <div className='leftContainer mb_space'>
        <div className='pt-4 mt-5 Orher_page_main_section'>
          <div className='main-area'>
            <div className='gameCard pt-2'>
              {addCaseSetting?.site_message ? (
                <div className='alrt_msg_div'>
                  <h5 className=''>
                    {JSON.parse(localStorage.getItem('sitSetting')) == 'undefined'
                      ? ''
                      : JSON.parse(localStorage.getItem('sitSetting'))
                        ?.site_message}
                  </h5>
                </div>)
                : ("")}
            </div>


            <div className="collapseCard-container">
              {udata?.verified == 'unverified' && (
                <div className="mb-2 collapseCard">
                  <Link to="/Profile">
                    <div className="collapseCard-body">
                      <div className="collapseCard-text text-dark">
                        <span className="text-danger">Please Complete Your KYC</span>
                      </div>
                    </div>
                  </Link>
                </div>
              )}
            </div>
            <section className='games-section'>
              <div className='d-flex align-items-center justify-content-between mt-3 mb-0'>
                <h3 className='tour_heading'>Our Tournaments</h3>
                <a className='btn-youtube-1' href="https://www.youtube.com/@ajsclub-q2d" target='_blank'>
                  <img src="/images/youtube.png" alt="YouTube" /> YouTube
                </a>
              </div>

              <div className='games-section-headline mt-0 mb-1'>
                <div className='games-window '>
                  <>
                    {/* =================Ludo Classic================ */}

                    <Link
                      className='gameCard-container mb-3'
                      to={`/Homepage/ludoClassicManual`}
                    >
                      <span className='d-none text-danger blink d-block text-right game_status_live'>
                        ◉ LIVE
                      </span>
                      <picture className='gameCard-image'>
                        <img

                          src={
                            process.env.PUBLIC_URL +
                            './mainimage/imageOne.jpg'
                          }
                          alt=''
                        />
                      </picture>
                    </Link>

                    {/* <Link
                      className='gameCard-container mb-3'
                      to={`/Homepage/ludoQuick`}
                    >
                      <span className='d-none text-danger blink d-block text-right game_status_live'>
                        ◉ LIVE
                      </span>
                      <picture className='gameCard-image'>
                        <img

                          src={
                            process.env.PUBLIC_URL +
                            './mainimage/imageThree.png'
                          }
                          alt=''
                        />
                      </picture>
                    </Link> */}

                    {/* =================Ludo snake================ */}
                    {/* /Homepage/LudoSnake */}
                    {/* <Link className='gameCard-container' to={''}
                    >
                      <span className='d-none blink text-danger d-block text-right game_status_live'>
                        ◉ COMMING SOON
                      </span>

                      <picture className='gameCard-image'>
                        <img
                          width='100%'
                          src={
                            process.env.PUBLIC_URL +
                            './mainimage/imageTwo.jpg'
                          }
                          alt=''
                        />
                      </picture>
                    </Link> */}

                    {/* <Link
                      className='gameCard-container'
                      to={`#`}
                    >
                      <span className='d-none blink text-danger d-block text-right game_status_live'>
                        ◉ Comming Soon
                      </span>
                      <picture className='gameCard-image'>
                        <img
                          width='100%'
                          src={
                            process.env.PUBLIC_URL +
                            './mainimage/imageThree.jpg'
                          }
                          alt=''
                        />
                      </picture>
                    </Link> */}
                    {/* =================Ludo Lite Classic================ */}
                    {/* <Link className='gameCard-container mb-3'
                  to={`/Homepage/Ludo%20Lite`}>
                  <span className='d-none blink text-success d-block text-right game_status_live'>
                    ◉ LIVE
                  </span>
                  <picture className='gameCard-image'>
                    <img
                     
                      src={
                        process.env.PUBLIC_URL +
                        './mainimage/ludo-lite-classic.jpg'
                      }
                      alt=''
                    />
                  </picture>
                </Link> */}
                    {/* =================Aviator================ */}
                      
                    {/* =================Color Pridection================ */}
                    {/* <Link className='gameCard-container'
                  to={`#`}>
                  <span className='d-none blink text-danger d-block text-right game_status_live'>
                    ◉ COMMING SOON
                  </span>
                  <picture className='gameCard-image'>
                    <img
                     
                      src={
                        process.env.PUBLIC_URL +
                        './mainimage/color.jpg'
                      }
                      alt=''
                    />
                  </picture>
                </Link>
                */}
                    {/* =================Ludo Snake================ */}


                    {/* =================Ludo rummy================ */}
                     <a className='gameCard-container' href={
                      JSON.parse(localStorage.getItem("sitSetting")) ==
                        "undefined"
                        ? ""
                        : JSON.parse(localStorage.getItem("sitSetting"))
                          ?.whatsappSupport
                    }
                      target="_blank">
                      <span className='d-none blink text-danger d-block text-right game_status_live'>
                        ◉ LIVE
                      </span>
                      <picture className='gameCard-image'>
                        <img
                          width='100%'
                          src={
                            process.env.PUBLIC_URL +
                            './mainimage/imageThree.png'
                          }
                          alt=''
                        />
                      </picture>
                    </a>
                    {/* <Link className="gameCard-container" to={`/Homepage/Ludo%20Ulta`} > */}
                  </>

                </div>
              </div>
            </section>

            <div className='d-flex align-items-center justify-content-center mt-0 mb-0'>
                <h3 className='tour_heading mb-2'>Our Tournaments</h3>
               </div>
            <div>
                <img className='w-100 rounded' src="/mainimage/sliderimage2.png"/>
            </div>

            <div className='downloadButton'>
              <Downloadbutton />
            </div>
          </div>
        </div>
      </div>
      <div className='rightContainer'>
        <Rightcontainer />
      </div>
    </>
  )
}
